import template from './time.dot';
const timeTemplate = template.default ? template.default : template;
export { timeTemplate };
